import { Injectable } from '@angular/core';
import { AuthService } from '@app/services/api/auth.service';
import {
  AdfsRedirect,
  AuthActionTypes,
  DeleteToken,
  DeleteTokenSuccess,
  Login,
  LoginFail,
  LoginRedirect,
  LoginSuccess,
  Logout,
  LogoutSuccess,
  SetToken
} from '@core/actions/auth.actions';

import { LoadSelf } from '@core/actions/user.actions';

import { Router } from '@angular/router';
import { FlashService } from '@app/services/flash.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import {
  catchError,
  concatMap,
  exhaustMap,
  map,
  tap
} from 'rxjs/operators';

import { environment } from '@environments/environment';

@Injectable()
export class AuthEffects {
  @Effect()
  login$: Observable<Action> = this.actions$.pipe(
    ofType<Login>(AuthActionTypes.Login),
    map(action => [action.email, action.password]),
    exhaustMap(([email, password]) =>
      this.auth.login(email, password).pipe(
        map(resp => resp && resp.accessToken),
        concatMap(token => [
          new SetToken(token),
          new LoadSelf(),
          new LoginSuccess(token)
        ]),
        catchError(error => of(new LoginFail(error)))
      )
    ),
    catchError(error => of(new LoginFail(error)))
  );

  @Effect({ dispatch: false })
  loginFail$ = this.actions$.pipe(
    ofType<LoginFail>(AuthActionTypes.LoginFail),
    map(action => action.error),
    tap(res =>
      this.flash.emit({
        message:
          res && res.error && res.error.error && res.error.error.message
            ? res.error.error.message
            : 'Error de servidor',
        type: 'danger'
      })
    )
  );

  @Effect({ dispatch: false })
  setToken$ = this.actions$.pipe(
    ofType<SetToken>(AuthActionTypes.SetToken),
    map(action => action.token),
    tap(token => this.auth.setCookie(token))
  );

  @Effect()
  deleteToken$ = this.actions$.pipe(
    ofType<DeleteToken>(AuthActionTypes.DeleteToken),
      tap(() => this.auth.deleteCookie()),
      map((action) => new DeleteTokenSuccess(action.typeView))
  );

  @Effect({ dispatch: false })
  loginSuccess$ = this.actions$.pipe(
    ofType<LoginSuccess>(AuthActionTypes.LoginSuccess),
    tap(token => this.router.navigate(['follows']))
  );

  @Effect()
  logout$: Observable<Action> = this.actions$.pipe(
    ofType<Logout>(AuthActionTypes.Logout),
    exhaustMap((action) => {
      return this.auth.logout().pipe(
        map(res => new LogoutSuccess(action.typeView)),
        catchError(error => of(new LoginFail(error))),
      )
    })
  );

  @Effect()
  logoutSuccess$ = this.actions$.pipe(
    ofType<LogoutSuccess>(AuthActionTypes.LogoutSuccess),
    map(() => new DeleteToken())
  );

  @Effect()
  deleteTokenSuccess = this.actions$.pipe(
    ofType<DeleteTokenSuccess>(AuthActionTypes.DeleteTokenSuccess),
    map((action) => {
      if(action && action.typeView){
        return new AdfsRedirect()
      }
      return new LoginRedirect()
    })
    // map((action) => new LoginRedirect())
  );

  @Effect({ dispatch: false })
  loginRedirect$: Observable<Action> = this.actions$.pipe(
    ofType<LoginRedirect>(AuthActionTypes.LoginRedirect),
    tap(() => {
      if(environment.ADFS_ONLY){
        this.router.navigate(['adfs'])
      }else{
        this.router.navigate(['login'])
      }
    })
  );

  @Effect({ dispatch: false })
  adfsRedirect$: Observable<Action> = this.actions$.pipe(
    ofType<AdfsRedirect>(AuthActionTypes.AdfsRedirect),
    tap(() => {
      this.router.navigate(['adfs'])
    })
  );

  constructor(
    private actions$: Actions,
    private auth: AuthService,
    private router: Router,
    private flash: FlashService
  ) {}
}
